import { render, staticRenderFns } from "./card_form.vue?vue&type=template&id=b4ef913a&scoped=true&lang=pug&"
import script from "./card_form.vue?vue&type=script&lang=js&"
export * from "./card_form.vue?vue&type=script&lang=js&"
import style0 from "./card_form.vue?vue&type=style&index=0&id=b4ef913a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ef913a",
  null
  
)

export default component.exports